import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router/composables";

import { apiClient } from "@/plugins/api-client";
import { ApiError } from "@/services";
import { useNotificationStore } from "@/stores/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const notificationStore = useNotificationStore();

const passwordRules = [
  (v: string) => !!v || "Password is required",
  (v: string) =>
    (v && v.length >= 8) || "Password must be more than 8 characters",
];

const passwordConfirmationRules = computed(() => {
  return [
    passwordConfirmation.value === password.value ||
      "Passwords must be identical",
  ];
});

const isLoading = ref(false);
const isFormValid = ref(false);
const password = ref("");
const passwordConfirmation = ref("");
const isPasswordVisible = ref(false);
const isPasswordConformationVisible = ref(false);

const resetPassword = async () => {
  isLoading.value = true;
  try {
    await apiClient.userManagement.resetPassword({
      token: route.query.token?.toString(),
      new_password: password.value,
    });
    notificationStore.success("Your password was reset.");
    await router.push({ name: "Login" });
  } catch (e: unknown) {
    const error = e as ApiError;
    if (error.status === 400 && error.body.detail) {
      notificationStore.error(error.body.detail);
    }
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,route, router, notificationStore, passwordRules, passwordConfirmationRules, isLoading, isFormValid, password, passwordConfirmation, isPasswordVisible, isPasswordConformationVisible, resetPassword }
}

})